var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.remainingTime > 0)?_c('span',{staticClass:"countdown"},[_vm._v(" "+_vm._s(_vm.formattedTime)+" ")]):_c('span',{staticClass:"countdown"},[_vm._v(" "+_vm._s(_vm.endText)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }